module.exports = __webpack_public_path__ + "media/images/icons/filled/code-sandbox-square-a07eccee04d77a52651b14c33d2122f3.svg";